import {trackEvent} from "../../library/analytics";

$(document).ready(function() {
    $('#list-pagination').on('change', '#pageSelector', function() {
        let selectedPage = $(this).val();
        let form = $(this).parents('form');
        trackEvent('Results', 'SelectPage', selectedPage, function() {
            form.submit();
        });
    });
});